import { ErrorBoundary } from '@sentry/react';
import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';

import { TableSkeleton } from '@eluve/blocks';
import {
  Content,
  Header,
  Heading,
  SidebarTrigger,
  Stack,
} from '@eluve/components';
import { useTranslation } from '@eluve/i18n';
import { useCaptureEventOnMount } from '@eluve/posthog-react';

import { PatientsList } from './PatientsList';

export const PatientsListPage: React.FC = () => {
  const { t } = useTranslation();
  useCaptureEventOnMount('page_view_patients_list');
  return (
    <>
      <Helmet>
        <title>Patients | Eluve</title>
      </Helmet>
      <Header>
        <SidebarTrigger />
        <div className="my-2 py-2">
          <Heading>{t('patients.list.title')}</Heading>
        </div>
      </Header>
      <Content padded>
        <Suspense fallback={<TableSkeleton rowCount={20} />}>
          <ErrorBoundary
            fallback={
              <Stack gap={2}>
                <p>{t('patients.list.loadFailed')}</p>
                <TableSkeleton rowCount={5} />
              </Stack>
            }
          >
            <PatientsList />
          </ErrorBoundary>
        </Suspense>
      </Content>
    </>
  );
};
